import { render } from "./GregPage.vue?vue&type=template&id=64715c85&scoped=true"
const script = {}

import "./GregPage.vue?vue&type=style&index=0&id=64715c85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64715c85"]])

export default __exports__